module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "story",
    attrs: {
      "id": "CreatingMissionalCulture-4.html",
      "xml:lang": "en-US"
    }
  }, [_c('h2', {
    staticClass: "Title",
    attrs: {
      "id": "heading_id_2"
    }
  }, [_vm._v("1"), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "alt": " ",
      "src": "Images/ShortLine.jpg"
    }
  }), _c('br'), _vm._v("\n    What Is Missional Culture and Why Does It Matter?")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("The Church is called to be a provisional demonstration of God’s will for all people.")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-source"
  }, [_vm._v("Presbyterian Book of Order")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_vm._v("Don’t become so well-adjusted "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("to your culture")]), _vm._v(" that you fit into it without even thinking. Instead, fix your attention on God. You’ll be changed from the inside out. Readily recognize what he wants from you, and quickly respond to it"), _c('span', {
    staticClass: "char-style-override-13"
  }, [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Unlike the culture")]), _vm._v(" around you, always dragging you down to its level of immaturity, God brings the best out of you, develops well-formed maturity in you.")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-source"
  }, [_vm._v("The Apostle Paul, Romans 12:2 "), _c('span', {
    staticClass: "char-style-override-10"
  }, [_vm._v("The Message")])]), _vm._v(" "), _c('p', {
    staticClass: "veryfirst"
  }, [_c('span', {
    staticClass: "first-words sgc-1"
  }, [_vm._v("I was driving in Columbus, Ohio,")]), _vm._v(" when I came upon a hitchhiker who alternated between holding his thumb out and clasping his hands together as if he were praying. I picked him up.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("His name was Mike, and I soon discovered he was a hardcore Aryan (white supremacist), pointing to a passage in Scripture about being “a chosen people” as the reason for his convictions. I asked if he would be willing to reread the passage in context. He agreed. As I reached in the back seat to grab my Bible, he pulled a gun and pointed it at my head. I assured him I was just getting my Bible, so he put his gun away, and my heart started to beat again.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("I realized Mike had no place to stay that night, so I invited him to stay with me.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("“You mean you would trust me to stay with you after pulling a gun on you?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("“Yes,” I said, “because God has given me a love for you that I can’t explain, and he loves you.” As I was saying this, I was saying to myself, "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Yeah, what am I thinking?")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Tears welled in Mike’s eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("We got back to the hotel where my roommate Tom and I were staying. I woke up my roommate to ask him if Mike could stay with us, mentioning that he had a gun. He wasn’t favorably disposed to the idea, so I ended up getting Mike another room. Mike didn’t want me to, but I insisted. It gave me the chance to share more of the gospel with him.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("We talked until 4 a.m., and I told him about the Jesus the apostles wrote about, this Jesus who had become my hero, my Savior and my example. I told him how Jesus was the liberator of those oppressed, the lover of those rejected and the deliverer of those seduced by consumerism, and Mike responded with tears of surrender.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Later that week he took me to a Chinese restaurant and continued to inquire about Jesus. I told him how Jesus lived his life for the sake of others, how he died so we could live, and how he rose again to show what God was going to do for the world.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Something in Mike changed that evening; he understood in a profound way who Jesus was and what he had done for him and the world. When I left Columbus, Mike had a heart to share with his Aryan friends what he had learned, hoping they would let go of their racism and be part of a community that included people from every race, tongue, tribe and nation.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As I reflect on my encounter with Mike, it reminds me of two realities: we live in a messed-up world filled with violence, prejudice, racism, poverty, greed, pride, envy, lust and gluttony; and Jesus has invited messed-up people like us to partner with God in the redemption of the world.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The Federal Aviation Administration once developed a cannon-like device to test the strength of windshields of airplanes. They actually shot a dead chicken (I’m serious) into the windshield at the approximate speed of a flying plane to simulate a bird hitting a plane while in flight. Well, a British locomotive company heard about this test. So they asked the FAA if they could borrow the device. They had just developed a high-speed train and they wanted to likewise test their windshield.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("They loaded the bird up and shot it at the locomotive at its approximate running speed. The bird went through the windshield, knocked over the engineer’s chair and put a dent in the cab of the locomotive. They couldn’t understand what had happened. So they asked if the FAA would please review all the things that the locomotive company had done. The FAA’s final report said, “You might want to try the test with thawed chicken.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Why did everyone in the locomotive company conclude that a frozen chicken was used in this experiment? There wasn’t even a debate about whether this should be a frozen chicken or"), _c('a', {
    attrs: {
      "id": "eNote0005"
    }
  }), _vm._v(" a thawed chicken—regular or crispy? No one asked this most basic question."), _c('span', {
    staticClass: "char-style-override-12"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/eNotes#eNote0005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[1]")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("We often jump to conclusions about how to make the church work better or how to develop a missional strategy—without asking some of the most basic questions. Questions like What does it mean to be the church today? What does it mean to create a missional culture and why does it matter?")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Creating a missional culture is more than just adding some outward programs to the church structure. Creating a missional culture goes to the heart and identity of God, to who we are and who we are becoming.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("Missio Dei")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("One of the most influential theologians of the last century, Karl Barth, was instrumental in the reintroduction of the classic doctrine of "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("missio Dei")]), _c('a', {
    attrs: {
      "id": "eNote0006"
    }
  }), _vm._v("."), _c('span', {
    staticClass: "char-style-override-12"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/eNotes#eNote0006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[2]")])]), _vm._v(" We find "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("missio Dei")]), _vm._v(" in Scripture: God the Father sends the Son and the Spirit into the world, and the Father, Son and Spirit send the church into the world "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("for")]), _vm._v(" the sake "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("of")]), _vm._v(" the world. In other words, mission does not originate with the church but is derived from the very nature of God. As Jürgen Moltmann has said, “It is not the church that has a mission of salvation to fulfill in the world; it is the mission of"), _c('a', {
    attrs: {
      "id": "eNote0007"
    }
  }), _vm._v(" the Son and the Spirit through the Father that includes the church.”"), _c('span', {
    staticClass: "char-style-override-12"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/eNotes#eNote0007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[3]")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("When we read the Scriptures, we learn that it is God’s mission to set things right in a broken and messed-up world. God’s mission is to redeem the world and restore it to its intended purpose. The church exists to fulfill God’s mission, and when we participate in God’s mission we become living signs of God’s intended future for the world, bringing glory to God. In other words, mission exists because God is a missionary God. And “a church which is not on mission is either not yet or no"), _c('a', {
    attrs: {
      "id": "eNote0008"
    }
  }), _vm._v(" longer the church, or only a dead church—itself in need of renewal.”"), _c('span', {
    staticClass: "char-style-override-12"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/eNotes#eNote0008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[4]")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If we seek to create a missional culture, it is imperative that we understand that God created the church as a sign, foretaste and instrument"), _c('a', {
    attrs: {
      "id": "eNote0009"
    }
  }), _vm._v(" by which more of his kingdom would be realized here on earth."), _c('span', {
    staticClass: "char-style-override-12"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/eNotes#eNote0009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[5]")])])]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("Church as Sign, Foretaste and Instrument")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("Sign")]), _c('span', {
    staticClass: "char-style-override-1"
  }, [_vm._v(".")]), _vm._v(" The church is to be a sign of God’s coming kingdom, pointing people to a reality that is right around the corner. Jesus said, “You are the light of the world.” We are called to be lights that point others toward God, his Son and his future. So what kind of sign are we? What kind of sign do we want to become?")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("Foretaste")]), _c('span', {
    staticClass: "char-style-override-1"
  }, [_vm._v(".")]), _vm._v(" The church is called to be a foretaste of God’s kingdom, a place where people can get a taste of the future in the present. When the church is a foretaste, it demonstrates what life is like when men and women live under the rule and reign of God, when the people of God love one another, exhort one another, encourage one another, forgive one another and live in harmony with one another. In this way the church becomes a concrete, tangible, though not perfect, foretaste of the kingdom that is to come.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('span', {
    staticClass: "char-style-override-2"
  }, [_vm._v("Instrument")]), _c('span', {
    staticClass: "char-style-override-1"
  }, [_vm._v(".")]), _vm._v(" Creating a missional culture requires not only understanding that the church is called to be a sign and foretaste of God’s kingdom, but also an instrument. When writing to the church in Ephesus the apostle Paul talks about how the church is God’s chosen instrument to show the manifold wisdom and grace of God to both the visible and invisible world. He says, “His intent was that now, through the church, the manifold wisdom of God should be made known to the rulers and authorities in the heavenly realms, according to his eternal purpose that he accomplished in Christ Jesus our Lord” (Eph 3:10-11). We see throughout the letter to the Ephesians that the church is to be like a preview or movie trailer of what is to come. The church is an instrument through which God’s will for justice, peace and freedom is done in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Creating a missional culture helps the church live out her calling to be a sign of the kingdom, pointing people to the reality beyond what we can see, a foretaste of the kingdom where we grow to love one another as Christ loves us, and an instrument in the hands of God to bring more of heaven to earth in concrete ways. For the church is to be a credible sign, foretaste and instrument, it needs to be a community rich with the fruit of the spirit.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("The Problem")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Yet in our most honest moments we recognize that we aren’t the kind of people that God wants us to be. We aren’t even the kind of people that we hope to be. To be honest, "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("sometimes")]), _vm._v(" when I look at the worldwide and local church, including churches I have pastored, I think, "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("God, this is just one big mess!")]), _vm._v(" And apparently, I’m not the only one who thinks this.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In March 2009 we received the results from the widest religious survey conducted in the United States, the ARIS (American Religious Identification Survey) study. There is much to gain from this report, which is based on over 54,000 interviews conducted from February to November 2008. This survey was a continuation of the ARIS surveys in 1990 and 2001, which are part of the landmark series by the Program of Public Affairs at Trinity College in Hartford, Connecticut.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The report indicates major shifts in the American landscape in the past eighteen years, including the fact that the percentage of people who call themselves some type of Christian has dropped more than 11 percent in a generation. One of the most widely cited results from this survey is the significant rise in the number of those who claim no religious identification or faith. This group has grown from 8.2 percent in 1990 to 15 percent in 2008. Ariela Keysar, the associate director of the study, says that the none’s (nonreligious) are the only group to have grown in every state of the union.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("So why are more and more people in the United States no longer identifying themselves as Christians? What is turning people off to the church, or at least some forms of the church? And why is the digital generation the least involved?")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("While there is no simple answer to these questions, I want to suggest that at the heart of the matter is the lack of mature missional disciples, not just as individuals but as communities of God’s people. We need to be more like Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Neil Cole makes a good point when he says,")]), _vm._v(" "), _c('p', {
    staticClass: "block-single"
  }, [_vm._v("Ultimately, each church will be evaluated by only one thing—its disciples. Your church is only as good as her disciples. It does not matter how good your praise, preaching, programs or property are; if your disciples are passive, needy, consumeristic, and not"), _c('a', {
    attrs: {
      "id": "eNote0010"
    }
  }), _vm._v(" [moving in the direction of radical obedience,] your church is not good."), _c('span', {
    staticClass: "char-style-override-12"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/eNotes#eNote0010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[6]")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Stanley Hauerwas says the same thing in another way, “[The most important social task of Christians] is nothing less than to be a community capable of forming people with virtues sufficient to witness to God’s truth in the world. . . . [T]he task of the Church . . . is to become a"), _c('a', {
    attrs: {
      "id": "eNote0011"
    }
  }), _vm._v(" polity that has the character necessary to survive as a truthful society.”"), _c('span', {
    staticClass: "char-style-override-12"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/eNotes#eNote0011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[7]")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("So why do we lack mature disciples and mature communities of faith? One reason is that we fail to understand the hidden power of culture in life transformation.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Individualism saturates American culture to the point that we no longer notice it. Individualism tells us we can become more like Jesus by ourselves, through a self-help program or more effort. But the gospel tells us transformation happens as we embrace the work of the Spirit in "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("our")]), _vm._v(" lives together. Becoming more like Jesus is not a matter of trying but yielding, setting the sails of "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("our")]), _vm._v(" lives to catch the wind of the Spirit. It happens when we develop a communal rhythm of life—a collection of thick, bodily practices (liturgies) that engage our senses, grab our hearts, form our identities and reshape our desires toward God and his kingdom. As we collectively engage in grace-filled spiritual practices, we cultivate particular environments that help to create a missional culture, which in turn reshapes us. As coworkers with God, we create culture and culture reshapes us. Understanding the transformative power of culture is vital if we want to have mature communities of faith.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Phillip Kenneson, in his book "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Life on the Vine")]), _vm._v(", gives a vivid picture of what it means to be a mature community of faith. Using the fruit of the Spirit listed in Galatians, he offers a picture of what Christ is seeking to do in and through us. A mature community cultivates a lifestyle of love in the midst of market-style exchanges: a lifestyle of joy in the midst of manufactured desire, peace in the midst of fragmentation, patience in the midst of productivity, kindness in the midst of self-sufficiency, goodness in the midst of self-help, faithfulness in the midst of impermanence, gentleness in the midst of aggression, and self-control in the midst of addiction.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("The Power of Culture")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("In "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Theories of Culture")]), _vm._v(", Kathryn Tanner makes this remarkable statement,")]), _vm._v(" "), _c('p', {
    staticClass: "block-single"
  }, [_vm._v("Although less than one hundred years old, the modern anthropological meaning of “culture” now enjoys a remarkable influence within humanistic disciplines of the academy and within commonsense discussions of daily life. “In explanatory importance and in generality of application it is comparable to"), _c('a', {
    attrs: {
      "id": "eNote0012"
    }
  }), _vm._v(" such categories as gravity in physics, disease in medicine, evolution in biology.”"), _c('span', {
    staticClass: "char-style-override-12"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/eNotes#eNote0012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[8]")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("In other words, the idea of “culture” shapes everything we do as humans, from our thoughts while alone to how we develop family systems, to our interactions at the workplace, to the ways a specific country does its politics.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Kenneson understands the power of culture in the development of character. Culture has particular "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("narratives")]), _vm._v(", "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("institutions")]), _vm._v(", "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("rituals")]), _vm._v(" and "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("ethics")]), _vm._v(" that shape us as people. The dominant culture seeks to squeeze us (the church) into its mold of market-style exchanges, manufactured desire, self-sufficiency and addiction. The apostle Paul puts it this way,")]), _vm._v(" "), _c('p', {
    staticClass: "block-single"
  }, [_vm._v("Don’t become so well-adjusted "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("to your culture")]), _vm._v(" that you fit into it without even thinking. Instead, fix your attention on God. You’ll be changed from the inside out. Readily recognize what he wants from you, and quickly respond to it"), _c('span', {
    staticClass: "char-style-override-1"
  }, [_vm._v(".")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Unlike the culture")]), _vm._v(" around you, always dragging you down to its level of immaturity, God brings the best out of you, develops well-formed maturity in you. (Rom 12:2 "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("The Message")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Paul tells us that the dominant culture shapes who we become. According to cultural theory, culture is largely made up of artifacts, language, rituals, ethics, institutions and narratives. In other words, the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("language")]), _vm._v(" we live in, the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("artifacts")]), _vm._v(" that we use, the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("rituals")]), _vm._v(" we engage in, our approach to "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("ethics")]), _vm._v(", the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("institutions")]), _vm._v(" we are a part of and the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("narratives")]), _vm._v(" that we listen to have the power to shape our lives profoundly.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("As we look at the culture around us, here are some questions to help us understand how we are being shaped:")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "bullet-list-first"
  }, [_vm._v("What is the guiding "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("narrative")]), _vm._v(" of our host culture?")]), _vm._v(" "), _c('li', {
    staticClass: "bullet-list"
  }, [_vm._v("Which "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("institutions")]), _vm._v(" most shape our lives?")]), _vm._v(" "), _c('li', {
    staticClass: "bullet-list"
  }, [_vm._v("What "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("ethics")]), _vm._v(" are we developing in light of the stories and narratives that bombard us from every side?")]), _vm._v(" "), _c('li', {
    staticClass: "bullet-list-last"
  }, [_vm._v("What "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("rituals,")]), _vm._v(" "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("practices")]), _vm._v(" and "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("liturgies")]), _vm._v(" are we engaging in that shape our desires, our idea of the “good life” and the kind of people we are becoming?")])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("If we take a quick look at American culture, we can see that an individualistic and consumer "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("narrative")]), _vm._v(" shapes much of our culture and thereby socialized us. We are all socialized beings.")]), _vm._v(" "), _c('p', {
    staticClass: "block-single"
  }, [_vm._v("Socialization—the process of growing up within a culture—involves internalizing our culture’s way of seeing things. . . . The result is that we do not simply “see” life, but we see it in enculturated ways. . . . We are likely to feel good or not good about ourselves on the basis of how well we"), _c('a', {
    attrs: {
      "id": "eNote0013"
    }
  }), _vm._v(" live up to the messages and standards of culture internalized within us."), _c('span', {
    staticClass: "char-style-override-12"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/eNotes#eNote0013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[9]")])])]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Our "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("narrative")]), _vm._v(" of growth and success includes the ability to purchase comfort, security and stability. We are socialized from a young age to believe that fulfillment comes through products. Research indicates that children can identify a brand as young"), _c('a', {
    attrs: {
      "id": "eNote0014"
    }
  }), _vm._v(" as eighteen months, and youth influence about $600 billion of adult spending."), _c('span', {
    staticClass: "char-style-override-12"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/eNotes#eNote0014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[10]")])]), _vm._v(" Some of our strongest "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("institutions")]), _vm._v(" are chain stores. We create "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("rituals")]), _vm._v(" around product consumption and hold closely to our brand-name "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("artifacts")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If we hope to experience transformation, we need to develop a culture in the congregation that encourages people to live "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("in")]), _vm._v(" the world for the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("sake of")]), _vm._v(" the world, without being "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("of")]), _vm._v(" the world. Gerhard Lohfink, in "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("Jesus and Community")]), _vm._v(", makes a strong case that it has always been God’s intention to work through a visible, tangible concrete community that lives as a contrast society "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("in")]), _vm._v(" the world "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("for")]), _c('a', {
    attrs: {
      "id": "eNote0015"
    }
  }), _vm._v(" the sake of the world."), _c('span', {
    staticClass: "char-style-override-12"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/eNotes#eNote0015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[11]")])]), _vm._v(" Tim Keller concurs when he says, “Christians are truly residents of the city, yet not seeking power over or the approval of the dominant culture. Rather, they show the"), _c('a', {
    attrs: {
      "id": "eNote0016"
    }
  }), _vm._v(" world an alternative way of living and of being a human community.”"), _c('span', {
    staticClass: "char-style-override-12"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/eNotes#eNote0016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("[12]")])]), _vm._v(" When we grasp the power of culture, it gives both perspective and fresh hope for transformation.")]), _vm._v(" "), _c('p', {
    staticClass: "subhead"
  }, [_vm._v("Leadership and Culture")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Leaders of God’s people uniquely contribute to the cultivation of a culture distinct and different from the dominant culture. For it is the role of Spirit-filled leaders to create a missional culture within the congregation. If we hope to create a missional culture, we must understand the power of culture in shaping the life of the congregation, and learn the basic elements of culture.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In addition, we must examine our very "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("approach")]), _vm._v(" to leadership. For an individualistic approach to leadership often leads to an individualistic approach to discipleship, while a shared approach to leadership often leads to a communal approach to discipleship with an appreciation of the life-shaping power of culture. To change the "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("ethos")]), _vm._v(" of the church we also need to change "), _c('span', {
    staticClass: "char-style-override-3"
  }, [_vm._v("our approach")]), _vm._v(" to leadership. I will address this later. But first we need to understand the nature of culture and how it works.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c23490d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/chap1.vue
// module id = 84
// module chunks = 0